import { cn } from "@/libs/utils";
import { useSanitizedHtml } from "@/hooks/useSanitizedHtml";

export function GameGuideMDViewer({
  theme,
  width,
  content,
  className,
}: {
  theme: string;
  width: string;
  content: any;
  className?: string;
}) {
  const sanitized = useSanitizedHtml(content ?? "");
  return (
    <article
      className={cn(
        "game-guide-md-viewer min-h-screen",
        theme === "black"
          ? "bg-gray_6 text-white_2 [&_.markdown-body_pre]:bg-gray_6"
          : "bg-white text-coolgray-70 [&_.markdown-body_pre]:bg-white",
        "[&_.markdown-body_pre_code]:whitespace-pre-wrap",
        "[&_.markdown-body_li]:list-disc [&_.markdown-body_li]:text-sm",
        "[&_.markdown-body_li_img]:w-full",
        className,
      )}
    >
      <div
        className="markdown-body"
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    </article>
  );
}

export function MDViewer({
  md,
  isError,
  type = "default",
  className,
  ...rest
}: { md: any; isError: boolean; type?: string; className?: string } & any) {
  const sanitized = useSanitizedHtml(md ?? "");
  return (
    <article className="markdown-body w-full pb-20 pt-10">
      <div>
        <article
          className={cn(
            "min-h-screen w-full bg-white text-black",
            "[&_.markdown-body_pre]:bg-white",
            "[&_.markdown-body_pre_code]:whitespace-pre-wrap",
            "[&_.markdown-body_p]:text-justify",
            "[&_.markdown-body_li]:list-disc",
            "[&_.markdown-body_li_img]:w-full",
          )}
        >
          <div
            className="markdown-body"
            dangerouslySetInnerHTML={{
              __html: sanitized,
            }}
          />
          {isError && <div>Could not fetch document. Try again Later.</div>}
        </article>
      </div>
    </article>
  );
}
